import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { deleteProfile } from "api/graphQL_users";
import DivLoader from "components/divloader/DivLoader";
import InputField from "components/fields/InputField";
import React from "react";
import { toast } from "react-hot-toast";
import { MdDelete, MdHighlightOff } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { clearAllCookie } from "utils/auth";
import { PROF_STYLES } from "./ChangePasswordModal";

const DeleteAccountModal = () => {
  const rootForm = { password: "" };
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [formValues, setFormValues] = React.useState<any>(rootForm);
  const [formValuesErr, setFormValuesErr] = React.useState<any>({});
  const [passwordShow, setPasswordShow] = React.useState(false);
  const [isCloseModal, setIsCloseModal] = React.useState(false);

  const logout = () => { clearAllCookie(); navigate("/auth/sign-in"); };

  const handleClose = () => {
    setIsCloseModal(true);
    setFormValues(rootForm); setFormValuesErr({});
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  function handleValueChange(e: any) {
    setFormValues((p: any) => ({ ...p, [e.target.id]: e.target.value }));
    setFormValuesErr((p: any) => ({ ...p, [e.target.id]: "" }));
  }

  function validateData() {
    let errors: any = {};
    const v = (formValues.password || "").trim();
    if (!v) errors.password = "The field is required";
    else if (v.length < 8) errors.password = "Password must be at least 8 characters";
    setFormValuesErr(errors);
    return Object.keys(errors).length === 0;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();
    if (!validateData()) return;
    try {
      setIsLoading(true);
      const response = await deleteProfile(formValues);
      if (response.status === "Error") toast.error(response?.message ?? "Please provide valid values");
      else { toast.success("Account deleted successfully"); handleClose(); logout(); }
    } catch (err: any) {
      toast.error(err?.response?.data?.message ?? "Unable to delete account");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <button className="prof-action-btn prof-action-btn--red" onClick={onOpen}>
        <MdDelete size={14} />
        Delete Account
      </button>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`prof-panel${isOpen && !isCloseModal ? " prof-panel--open" : " prof-panel--close"}`}>
          <div className="prof-glow prof-glow--red" />

          <div className="prof-header prof-header--red">
            <div className="prof-header-brand">
              <div className="prof-header-logo">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
                  <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                </svg>
              </div>
              <div>
                <h2 className="prof-title">Delete Account</h2>
                <p className="prof-sub">This action is permanent and irreversible</p>
              </div>
            </div>
            <button className="prof-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="prof-body">
            {/* Warning block */}
            <div className="prof-warning">
              <div className="prof-warning-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div>
                <p className="prof-warning-title">You are about to delete your account</p>
                <p className="prof-warning-desc">
                  This will permanently remove your account and all associated data.
                  Please enter your password to confirm this action.
                </p>
              </div>
            </div>

            <div className="prof-field-group">
              <InputField
                variant="auth" extra="w-full"
                label="Confirm Password *" placeholder="••••••••"
                id="password"
                type={passwordShow ? "text" : "password"}
                value={formValues?.password}
                errMessage={formValuesErr?.password}
                onChange={handleValueChange}
                passwordShow={passwordShow}
                setPasswordShow={setPasswordShow}
              />
            </div>
          </div>

          <div className="prof-footer">
            <button className="prof-btn-cancel" onClick={handleClose}>Cancel</button>
            <button className="prof-btn-submit--red" onClick={handleSubmit} disabled={!!isLoading}>
              {isLoading ? <span className="prof-spinner" /> : (
                <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/></svg>Delete Account</>
              )}
            </button>
          </div>
        </div>
      </Modal>

      {PROF_STYLES}
    </>
  );
};

export default DeleteAccountModal;